import {
  type WorkplaceProfileResponse,
  workplaceProfileResponseSchema,
  workplaceProfileUpdateSchema,
} from "@clipboard-health/contract-backend-main";
import { patch } from "@src/appV2/api/parsedApi";
import { environmentConfig } from "@src/appV2/environment";
import { useMutation, type UseMutationOptions } from "@tanstack/react-query";

interface UpdateShiftBookedChatNotificationParams {
  workplaceId: string;
  isShiftBookedChatNotificationEnabled: boolean;
}

export function useUpdateShiftBookedChatNotification(
  options: UseMutationOptions<
    WorkplaceProfileResponse,
    unknown,
    UpdateShiftBookedChatNotificationParams
  > = {}
) {
  return useMutation({
    mutationFn: async ({ workplaceId, isShiftBookedChatNotificationEnabled }) => {
      const response = await patch({
        url: `${environmentConfig.REACT_APP_BASE_API_URL}/workplaces/${workplaceId}`,
        data: {
          data: {
            id: workplaceId,
            type: "workplace",
            attributes: { isShiftBookedChatNotificationEnabled },
          },
        },
        bodySchema: workplaceProfileUpdateSchema,
        responseSchema: workplaceProfileResponseSchema,
      });
      return response.data;
    },
    ...options,
  });
}
